package org.chiangmeng.qfast.core.domain.usecases

class QueueStatusUseCase {
    fun execute(myTicketNumber: Int, currentServing: Int): TicketStatus {
        return when {
            myTicketNumber < currentServing -> TicketStatus.EXPIRED
            myTicketNumber == currentServing -> TicketStatus.NOW_SERVING
            else -> TicketStatus.WAITING
        }
    }
}